import portal from "portalConfig"

export default function formatPrice({ value }) {
  const withoutCents = value % 1 === 0
  const { currency = "USD" } = portal.config

  const formatter = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
    minimumFractionDigits: withoutCents ? 0 : 2
  })

  return formatter.format(value)
}
